


export function ContentWrapper({children}){
    return(
        <div className="nv-contentWrapper d-flex flex-column">
            {children}
        </div>
    )
}